import { render, staticRenderFns } from "./Kelulusan.vue?vue&type=template&id=4ffd85dd&scoped=true"
import script from "./Kelulusan.vue?vue&type=script&lang=js"
export * from "./Kelulusan.vue?vue&type=script&lang=js"
import style0 from "./Kelulusan.vue?vue&type=style&index=0&id=4ffd85dd&prod&lang=css"
import style1 from "./Kelulusan.vue?vue&type=style&index=1&id=4ffd85dd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd85dd",
  null
  
)

export default component.exports